import axios from "axios";
import moment from "moment";

import store from "../store";

class Client {
	async put(
		tables = null,
		profile = null,
		style = null,
		client_var = null,
		env = null,
		database = null,
		viewver = null,
		tags = null,
		actions_help = null,
		document_extraction = null, 
		document_extraction_type = null,
		prestashop = null,
		columns_ged = undefined,
		tags_editable = undefined,
		tags_col_visible = undefined
	) {
		let jwt = store.state.jwt;

		var obj = {};

		if (tables) obj.tables = tables;

		if (prestashop) obj.prestashop = prestashop;

		if (profile) obj.profile = profile;

		if (style) obj.style = style;

		if (client_var) obj.var = client_var;

		if (env) obj.env = env;

		if (database) obj.database = database;

		if (viewver) obj.viewver = viewver;
		
		if (tags) obj.tags = tags;

		if (actions_help) obj.actions_help = actions_help

		if (document_extraction) obj.document_extraction = document_extraction
		
		if (document_extraction_type) obj.document_extraction_type = document_extraction_type

		if (columns_ged !== undefined) obj.columns_ged = columns_ged;

		if (tags_editable !== undefined) obj.tags_editable = tags_editable;

		if (tags_col_visible !== undefined) obj.tags_col_visible = tags_col_visible;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/put", obj, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async put_admin(client)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/put_admin", {client}, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClientUsers(params = {}) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/users", {
					params,
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClientGroups() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/groupes", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.groups);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClients() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/all", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.clients);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async addCredit(client_uid, credits)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/credit", {client_uid, credits}, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async creditHistory(page)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/credit/history/" + page, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.history);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async creditHistoryDate()
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/credit/history",
					{
						date_begin: moment().subtract(1, 'months').format("YYYY-MM-DD"),
						date_end: moment().add(1, 'days').format("YYYY-MM-DD")
					},
					{
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.result);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getBandwidth(all = false)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/bandwidth",
					{
						date_begin: moment().subtract(1, 'months').format("YYYY-MM-DD"),
						date_end: moment().add(1, 'days').format("YYYY-MM-DD"),
						all: all
					},
					{
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.result);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getEditorBandwidth(all = false)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/editor_bandwidth",
					{
						date_begin: moment().subtract(1, 'months').format("YYYY-MM-DD"),
						date_end: moment().add(1, 'days').format("YYYY-MM-DD"),
						all: all
					},
					{
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.result);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Client();
